import { isLocal } from './index';

const supportCache: { [key: string]: null | boolean } = {
  webp: null
};

export function supportWebp() {
  if (supportCache.webp === null) {
    supportCache.webp =
      document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') === 0;
  }
  return supportCache.webp;
}

// image x
export const IMAGEX_URL = '//p16-cc-sg.ibyteimg.com'; // TODO: sg imagex url

// todo change to online config
export const ImagexTplSuffix = {
  q70: '~tplv-hdprqziq2y-q70.jpeg', // compress quality 70 with jpg
  webp: '~tplv-hdprqziq2y-webp.webp', // use webp
  bcmodal: '~tplv-hdprqziq2y-bcmodal.jpeg'
};

export function getTosImageUrl(uri: string, tplType?: any) {
  if (uri.includes('http')) return uri;
  if (isLocal) {
    return `//tosv.boei18n.remove.this/obj${uri}`;
  }
  if (!uri || !uri.trim()) return '';
  const suffix = tplType || (supportWebp() ? ImagexTplSuffix.webp : ImagexTplSuffix.q70);
  // tos img bucket
  return `${IMAGEX_URL}/img${uri}${suffix}`;
}

export function getTosFileUrl(uri: string, bucketToReplace?: string) {
  if (typeof uri !== 'string') {
    return uri;
  }
  if (uri.includes('http')) {
    return uri;
  }
  if (isLocal) {
    return `${atob('Ly90b3N2LmJvZWkxOG4uYnl0ZWQub3JnL29iai8=')}${uri}`;
  }
  const fixedUri = uri[0] === '/' ? uri.slice(1) : uri;

  const host = ['lf16-adcdn-sg.ibytedtos.com', 'lf19-adcdn-sg.ibytedtos.com', 'lf21-adcdn-sg.ibytedtos.com '];
  const [, uniqueName] = fixedUri.split('/');
  return `//${host[0]}/obj/${bucketToReplace ? `${bucketToReplace}/${uniqueName}` : fixedUri}`;
}
